var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn_comment_24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25,36 C20.12475,36 19.99875,35.9685305 19.88475,35.9048422 C19.614,35.7542381 19.464,35.4522806 19.50825,35.1443289 L20.19375,30.3527208 C17.0205,28.6608598 15,25.3438232 15,21.7518029 C15,16.3750117 19.37925,12 24.762,12 L29.23875,12 C34.62075,12 39,16.3750117 39,21.7518029 C39,27.1285942 34.62075,31.5043552 29.238,31.5043552 L25.9215,31.5043552 L20.73,35.8269177 C20.59275,35.9415566 20.42175,36 20.25,36 Z M24.762,13.4985483 C20.20575,13.4985483 16.5,17.2007118 16.5,21.7518029 C16.5,24.9489557 18.3945,27.8891074 21.32625,29.2437951 C21.627,29.3824108 21.801,29.7016016 21.75375,30.0297836 L21.2685,33.4277419 L25.17,30.1788892 C25.305,30.0672474 25.4745,30.0058069 25.65,30.0058069 L29.238,30.0058069 C33.79425,30.0058069 37.5,26.3036433 37.5,21.7518029 C37.5,17.1999625 33.79425,13.4985483 29.238,13.4985483 L24.762,13.4985483 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work-in-progress",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PDFtron/Drop-Pin-Copy",
    transform: "translate(-410.000000, -1002.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Highlight-Menu-Copy",
    transform: "translate(395.000000, 990.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icn_comment_24px",
    fill: "#8A8E96",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.ac1ebb419b0451676917e451c971ab90.svg";
export { ForwardRef as ReactComponent };